import { useCallback, useState } from 'react';
import { useDragResize } from './useDragResize';

interface IProps {
  minWidth: number;
  maxWidth: number;
  initialWidth: number;
  onResizeEnd: (width: number) => void;
}

const useSidebarResizable = ({
  minWidth,
  maxWidth,
  initialWidth,
  onResizeEnd,
}: IProps) => {
  const [width, setWidth] = useState(initialWidth);

  const handleResizeProgress = useCallback(
    (event: MouseEvent) => {
      const delta = event.movementX;

      setWidth((prevState) => {
        const result = prevState - delta;

        // Check limits
        if (result < minWidth) {
          return minWidth;
        }
        if (result > maxWidth) {
          return maxWidth;
        }

        return result;
      });
    },
    [maxWidth, minWidth],
  );

  const handleResizeEnd = useCallback(
    (_: MouseEvent, finalWidth: number) => {
      if (finalWidth !== width) {
        onResizeEnd(width);
      }
    },
    [onResizeEnd, width],
  );

  const { handleResizeStart } = useDragResize({
    onResizeProgress: handleResizeProgress,
    onResizeEnd: handleResizeEnd,
  });

  return {
    width,
    startResize: (e: React.MouseEvent<HTMLElement>) => {
      e.preventDefault();
      handleResizeStart(e, width);
    },
  };
};

export default useSidebarResizable;
